export const INVITE_ID_LS_KEY = 'inviteId';
export const INVITE_CONTENT_PATH_LS_KEY = 'inviteContentPath';
export const INVITE_CLAIMER_RESULT_LS_KEY = 'inviteClaimResult';
export const INVITE_WELCOME_SEEN_LS_KEY = 'inviteWelcomeSeen';
/** id найновішого InviteReferral, про який уже показали toast (або «засіяли» в LocalStorage без toast) */
export const INVITE_REFERRAL_LAST_NOTIFIED_ID_LS_KEY = 'inviteReferralLastNotifiedId';
/** стан reveal анімації села + joined-теги на 24 год */
export const INVITE_VILLAGE_REVEAL_STATE_LS_KEY = 'inviteVillageRevealState';

export const INVITE_COMPLETE_MAX_RETRIES = 3;
export const INVITE_COMPLETE_RETRY_DELAY_MS = 5000;

/** власний будинок + до 9 запрошених */
export const VILLAGE_MAX_HOUSES = 10;
export const VILLAGE_MAX_INVITED_HOUSES = 9;
/** скільки тримаємо старе зображення перед Light Spiral */
export const VILLAGE_REVEAL_HOLD_MS = 1500;
/** скільки показуємо village.tag.joined після reveal */
export const VILLAGE_JOINED_TAG_TTL_MS = 24 * 60 * 60 * 1000;
